import { render, staticRenderFns } from "./NicheArea.vue?vue&type=template&id=7e13ece9&scoped=true"
import script from "./NicheArea.vue?vue&type=script&lang=js"
export * from "./NicheArea.vue?vue&type=script&lang=js"
import style0 from "./NicheArea.vue?vue&type=style&index=0&id=7e13ece9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e13ece9",
  null
  
)

export default component.exports